import React from 'react';
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import {getGameInstance, sendInput} from "../../actions/game-instance-actions";
// import MainMenu from './main-menu';
// import Rules from './rules';
// import IntroNode from './nodes/intro-node';
// import Round01Node from './nodes/round01-node';
// import Round02Node from './nodes/round02-node';
// import Round03Node from './nodes/round03-node';
// import FinalNode from './nodes/final-node';
// import {Route, Switch} from "react-router-dom";
// import BonusTasksIndex from './bonus-tasks/index';
import GameComponent from "./game-component";
import {getCreativeTasks} from "../../actions/creative-tasks-actions";
// import BankruptcyModal from "./events/bankruptcy_modal";
import {loadQuestions} from "../../actions/knowledge-questions";
import Loading from "../layout/loading";
import {setTheme} from "../../actions/theme-actions";
import PrimarySchool from "./instance/primary_school";
import SecondarySchool from "./instance/secondary_school";
import {withRouter} from "react-router-dom";

class GameIndex extends GameComponent {

    constructor(params) {
        super(params);
        this.state = {
            instanceId: null
        };
    }

    componentWillMount() {
    }

    componentWillReceiveProps(nextProps, nextContext) {
        let gameInstanceId = nextProps.match.params.id;
        const { loading, instance } = this.props.gameInstance;

        if ( this.state.instanceId === null || gameInstanceId !== this.state.instanceId ) {
            this.setState({ instanceId: gameInstanceId });
            this.props.getGameInstance(gameInstanceId);
            this.props.getCreativeTasks(gameInstanceId);
            this.props.loadQuestions(gameInstanceId);
        }
    }

    componentDidMount() {
        this.props.setTheme('ingame');
    }

    componentWillUnmount() {
        this.props.setTheme();
    }

    render() {
        if (this.props.gameInstance.loading || this.props.creativeTasks.loading )
            return (<Loading/>);

        const { instance } = this.props.gameInstance;

        if (!instance) {
            return (
                <div>
                    <div className='alert alert-warning'>An error occurred: Failed to load game</div>
                </div>
            );
        }

        let profile = (<div></div>);
        if (instance.getProperty('PROFILE_KIND')) {
            let profileData = instance.getProperty('PROFILE_KIND');
            profile = (<div>Profil: { profileData['properties']['category'] } / { profileData['properties']['name'] }</div>);
        }

        switch ( instance.getType() ) {
            case "Game::YourchanceInstance":
                return (<SecondarySchool mainClass={this.props.mainClass}/>);

            case "Game::Instance::Zs2019":
                return (<PrimarySchool mainClass={this.props.mainClass}/>);

            case "Game::Instance::Zs2020":
                return (<PrimarySchool mainClass={this.props.mainClass}/>);
        }
    }
}

function mapStateToProps(state,ownProps) {
    return {
        gameInstance: state.gameInstance,
        knowledgeQuestions: state.knowledgeQuestions,
        creativeTasks: state.creativeTasks,
        theme: state.theme
    };
}

function matchDispatchToProps(dispatch){
    return bindActionCreators({
        getGameInstance: getGameInstance,
        sendInput: sendInput,
        getCreativeTasks: getCreativeTasks,
        loadQuestions: loadQuestions,
        setTheme: setTheme
    }, dispatch);
}

export default withRouter(connect(mapStateToProps, matchDispatchToProps)(GameIndex));
